/**
 * Class used to provide lock mechanism
 */
export class LockObject {
    constructor() {
        /**
         * Gets or set if the lock is engaged
         */
        this.lock = false;
    }
}
//# sourceMappingURL=lockObject.js.map